module.exports = __webpack_public_path__ + "static/media/CrashBandicoot.e0e931bc.png";